<template>
  <c-form-dialog
    :model-value="isShown"
    :max-width="400"
    :title="$t('dashboard.telegram_bot')"
    @update:model-value="closeDialog()"
  >
    <div class="text-center">
      <v-icon size="60" color="info"> $telegram </v-icon>
      <p class="fs-16 fw-400 lh-120 mt-4">
        {{ $t('dashboard.telegram_banner', { name: adNetwork.name }) }}
      </p>
      <subscribe-telegram
        :gtm-event="GTM_EVENTS.TELEGRAM_SUBSCRIBE_DIALOG"
        class="mt-5"
        @subscribe="$emit('close')"
      />
    </div>
  </c-form-dialog>
</template>

<script>
  import { mapState } from 'pinia'
  import { gtmEvents } from '@clickadilla/components/constants'
  import { CFormDialog } from '@clickadilla/components/components'
  import { useSettingsStore } from '@/store/settings/settings'
  import SubscribeTelegram from '@/components/SubscribeTelegram.vue'
  import gtmPush from '@/services/utils/gtm-push'

  export default {
    name: 'SubscribeTelegramDialog',
    components: {
      CFormDialog,
      SubscribeTelegram
    },
    props: {
      isShown: {
        type: Boolean,
        required: true
      }
    },
    emits: ['close'],
    data() {
      return {
        GTM_EVENTS: gtmEvents
      }
    },
    computed: {
      ...mapState(useSettingsStore, ['adNetwork'])
    },
    beforeUnmount() {
      this.$emit('close')
    },
    methods: {
      closeDialog() {
        gtmPush({ event: gtmEvents.TELEGRAM_CLOSE_DIALOG })
        this.$emit('close')
      }
    }
  }
</script>
